import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import OrderBundleRoutes from './routes'

const OrderBundleEdit = () => {
  const { orderBundleId } = useNumericParams()

  useReduxAction(
    'orderBundles',
    'loadOrderBundle',
    {
      entityId: orderBundleId,
      ...defaultRequestOptions.orderBundle,
    },
    [orderBundleId],
    {
      dispatchAction: (action, requestOptions) => action(orderBundleId, requestOptions),
      shouldPerformFn: ({ loading }) => orderBundleId && !loading,
    },
  )

  return (
    <OrderBundleRoutes orderBundleId={orderBundleId} />
  )
}

export default OrderBundleEdit
